/**
 * 浏览器环境下的路径工具函数
 * 用于替代 Node.js 的 path 模块
 */

/**
 * 解析路径（替代 path.resolve）
 * @param {string} basePath - 基础路径
 * @param {string} routePath - 路由路径
 * @returns {string} 解析后的完整路径
 */
export function resolvePath(basePath, routePath) {
  // 如果 basePath 为空，直接返回 routePath
  if (!basePath) {
    return routePath;
  }
  
  // 如果 routePath 是外部链接，直接返回
  if (routePath.startsWith('http://') || routePath.startsWith('https://')) {
    return routePath;
  }
  
  // 如果 basePath 以 / 结尾，移除它
  const base = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
  
  // 如果 routePath 以 / 开头，直接返回
  if (routePath.startsWith('/')) {
    return routePath;
  }
  
  // 拼接路径
  return `${base}/${routePath}`;
}

/**
 * 判断是否为外部链接
 * @param {string} path - 路径
 * @returns {boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export default {
  resolvePath,
  isExternal
};
